export default "__VITE_ASSET__CVpMdUIt__"